import Spinner from 'gcs-common/components/Spinner/Spinner';
import { ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { PusherConnectionState } from 'gcs-common/pusher/pusher-constants';
import { getChatConnectionState } from 'gcs-common/slices/chatConnection/chatConnectionSelectors';
import { useSelector } from 'react-redux';
import { useDebounceValue } from 'usehooks-ts';
import styles from './styles.module.scss';

const ChatConnectionBanner = () => {
  const connectionStatus = useSelector(getChatConnectionState);
  const [debouncedConnectionStatus] = useDebounceValue(connectionStatus, 5000);

  if (!connectionStatus || connectionStatus === PusherConnectionState.Connected) {
    return null;
  }

  // to avoid banner flickering, we show the banner only after 5 seconds of being in a "bad" state
  switch (debouncedConnectionStatus) {
    case PusherConnectionState.Connecting:
      return (
        <div className={styles.reconnectingWrapper}>
          <Spinner size={ICON_SIZE.XX_SMALL} color={ICON_COLOR.WHITE} />
          &nbsp;Verbindung wiederherstellen
        </div>
      );
    case PusherConnectionState.Disconnected:
    case PusherConnectionState.Unavailable:
    case PusherConnectionState.Failed:
      return (
        <div className={styles.offlineWrapper}>
          <Spinner size={ICON_SIZE.XX_SMALL} color={ICON_COLOR.WHITE} />
          &nbsp;Sie sind offline, wir versuchen Sie wieder zu verbinden.
        </div>
      );
    default:
      return null;
  }
};

export default ChatConnectionBanner;
